/* eslint-disable prettier/prettier */
// src/presentation/SidebarConfig.js
import { SidebarService } from '../application/SidebarService';

const sidebarConfig = [];

try {
    const escapedJsonString = localStorage.getItem('permission');
    const trimmedString = escapedJsonString.replace(/^"(.*)"$/, '$1');
    const unescapedJsonString = trimmedString.replace(/\\"/g, '"');
    const permissionArray = JSON.parse(unescapedJsonString);
    if (Array.isArray(permissionArray)) {
        // 從 SidebarService 獲取新的側邊欄配置
        const newSidebarItems = SidebarService.getSidebarConfig(permissionArray);

        // 將新的側邊欄配置項目新增到 sidebarConfig 中
        sidebarConfig.push(...newSidebarItems);
    } else {
        console.warn('Permission is not an array:', permissionArray);
    }
} catch (e) {
    console.error('Error parsing permission:', e);
}

export default sidebarConfig;